import { HugeiconsIcon } from "@hugeicons/react";
import * as Icons from "@hugeicons/core-free-icons";

interface Props {
  name: string;
  className?: string;
  size?: number | string;
  color?: string;
  strokeWidth?: number;
}

const DynamicHugeIcon = ({ name, ...props }: Props) => {
  const IconComponent = (Icons as any)[name];

  if (!IconComponent) {
    return null;
  }

  return <HugeiconsIcon icon={IconComponent} {...props} />;
};

export default DynamicHugeIcon;
